/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_Type_LiveInputs */

const en_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const fr_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const de_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const it_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vivere`)
};

const ru_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жить`)
};

const es_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vivir`)
};

const zh_cn2_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居住`)
};

const ja_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブ`)
};

const hi_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रहना`)
};

const pt_pt2_options_general_project_type_live = /** @type {(inputs: Options_General_Project_Type_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Options_General_Project_Type_LiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type_live = /** @type {((inputs?: Options_General_Project_Type_LiveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_Type_LiveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_type_live(inputs)
	if (locale === "de") return de_options_general_project_type_live(inputs)
	if (locale === "it") return it_options_general_project_type_live(inputs)
	if (locale === "ru") return ru_options_general_project_type_live(inputs)
	if (locale === "es") return es_options_general_project_type_live(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_type_live(inputs)
	if (locale === "ja") return ja_options_general_project_type_live(inputs)
	if (locale === "hi") return hi_options_general_project_type_live(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_type_live(inputs)
	return en_options_general_project_type_live(inputs)
});